import { put, select, takeLatest } from 'redux-saga/effects'
import { getSignatureOptionsSelector } from '../../options/selectors'
import { SignaturesConstants } from '../store/signatures.constants'
import {
  setSectionIHeaderText,
  setUpdatedTermsText,
  setSectionIIIHeaderText,
  setSectionIIHeaderText,
  setAcknowledgmentText,
} from '../store/signatures.actions'
import { ISignatureOptionsState } from '../../options/store/options.types'
import { getPatientDemographicsSelector } from '../../patientDemographics/selectors/getPatientDemographics.selector'
import { IPatientDemographicsState } from '../../patientDemographics/store/patientDemographics.types'
import { ITripInformationState } from '../../tripInformation/store/tripInformation.types'
import { updateSignatureTerms } from '../../../utilities/signaturesTermConversion.util'
import { getTripInformationSelector } from '../../tripInformation/selectors'

export function* setUpdatedTerms() {
  const signatureOptionsState: ISignatureOptionsState = yield select(getSignatureOptionsSelector)
  const patientDemographics: IPatientDemographicsState = yield select(getPatientDemographicsSelector)
  const tripInformation: ITripInformationState = yield select(getTripInformationSelector)
  const { headerText, acknowledgmentText, sectionIText, sectionIIText, sectionIIIText } = signatureOptionsState

  const newHeaderText = updateSignatureTerms(headerText, patientDemographics, tripInformation)
  const newSectionIText = updateSignatureTerms(sectionIText, patientDemographics, tripInformation)
  const newSectionIIText = updateSignatureTerms(sectionIIText, patientDemographics, tripInformation)
  const newSectionIIIText = updateSignatureTerms(sectionIIIText, patientDemographics, tripInformation)

  yield put(setUpdatedTermsText(newHeaderText))
  yield put(setAcknowledgmentText(acknowledgmentText))
  yield put(setSectionIHeaderText(newSectionIText))
  yield put(setSectionIIHeaderText(newSectionIIText))
  yield put(setSectionIIIHeaderText(newSectionIIIText))
}
export function* setUpdatedTermsSaga() {
  yield takeLatest(
    [
      SignaturesConstants.SET_SIGNATURE_SECTION,
      SignaturesConstants.SET_SELECTED_SIGNATURE_TYPE,
      SignaturesConstants.GET_SIGNATURES,
    ],
    setUpdatedTerms
  )
}
